const KEY_PREFIX = "partzync_merchant_pos_category_id";

function storageKey(shopId: string, branchId: string): string {
  return `${KEY_PREFIX}:${shopId}:${branchId}`;
}

/** ໝວດທີ່ເລືອກຄັ້ງສຸດທ້າຍຕໍ່ຮ້ານ×ສາຂາ (sessionStorage) */
export function getStoredMerchantPosCategoryId(
  shopId: string,
  branchId: string,
): string | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(storageKey(shopId, branchId))?.trim();
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function setStoredMerchantPosCategoryId(
  shopId: string,
  branchId: string,
  categoryId: string | null,
): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    if (categoryId == null || categoryId === "") {
      sessionStorage.removeItem(storageKey(shopId, branchId));
    } else {
      sessionStorage.setItem(storageKey(shopId, branchId), categoryId);
    }
  } catch {
    /* ignore */
  }
}
